import { render, staticRenderFns } from "./refundReasonList.vue?vue&type=template&id=126c5c00&scoped=true&"
import script from "./refundReasonList.vue?vue&type=script&lang=js&"
export * from "./refundReasonList.vue?vue&type=script&lang=js&"
import style0 from "./refundReasonList.vue?vue&type=style&index=0&id=126c5c00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c5c00",
  null
  
)

export default component.exports